import { observer } from 'mobx-react-lite'
import { Box, Error, Typography } from 'shared/ui'
import { TimePicker } from 'shared/ui/DatePicker'
import type { GoogleCalendarPickerStore } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/googleCalendarPickerStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/styles.module.scss'

type IBookingStepAvailabilityTimeProps = {
  googleCalendarPickerStore: GoogleCalendarPickerStore
}

export const BookingStepAvailabilityTime = observer(
  ({ googleCalendarPickerStore }: IBookingStepAvailabilityTimeProps) => {
    const {
      availabilityFromDate,
      availabilityToDate,
      setAvailabilityFromDate,
      setAvailabilityToDate,
      availabilityTimeError,
    } = googleCalendarPickerStore

    return (
      <div className={styles.list}>
        <Box display={'flex'} gap={1}>
          <div className={styles.timePickerWrap}>
            <Typography
              variant={'text-input-label-small'}
              ariaLabel={'FromLabel'}
              color={'var(--content-primary-secondary)'}
            >
              From
            </Typography>
            <TimePicker
              selected={availabilityFromDate}
              onChange={setAvailabilityFromDate}
              textFieldPlaceholderProps={{
                className: styles.availabilityTimePicker,
              }}
              topListTextFieldProps={{ InputProps: { placeholder: 'From' } }}
              isTopReverse
            />
          </div>
          <div className={styles.timePickerWrap}>
            <Typography
              variant={'text-input-label-small'}
              ariaLabel={'ToLabel'}
              color={'var(--content-primary-secondary)'}
            >
              To
            </Typography>
            <TimePicker
              selected={availabilityToDate}
              onChange={setAvailabilityToDate}
              textFieldPlaceholderProps={{
                className: styles.availabilityTimePicker,
              }}
              topListTextFieldProps={{ InputProps: { placeholder: 'To' } }}
              isTopReverse
            />
          </div>
        </Box>
        <Error type={'text'} error={availabilityTimeError} />
      </div>
    )
  }
)
